import {
  Component,
  ChangeDetectionStrategy,
  Output,
  EventEmitter,
  InputSignal,
  input,
} from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-table-header',
    templateUrl: './table-header.component.html',
    styleUrls: ['./table-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CurrencyPipe, TranslatePipe]
})
export class TableHeaderComponent {
  readonly total: InputSignal<number | undefined> = input<number | undefined>(undefined);
  readonly title: InputSignal<string> = input<string>('');
  readonly value: InputSignal<number | undefined> = input<number | undefined>(undefined);
  readonly totalLabel: InputSignal<string> = input<string>('Total:');

  @Output()
  filter: EventEmitter<any> = new EventEmitter();
}
